import {Component} from '@angular/core';
import {Events, IonicPage, MenuController, NavController, NavParams, Platform} from 'ionic-angular';
import {AlertProvider} from '../../providers/alert/alert';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';
import {ProofProvider} from '../../providers/proof/proof';
import {AuthProvider} from '../../providers/auth/auth';

import {IdentificationCheckOnAppPage} from '../identification-check-on-app/identification-check-on-app';
import {IdentificationCheckOnWebPage} from '../identification-check-on-web/identification-check-on-web';

/**
 * Generated class for the ProofTermsBeforeBeginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-terms-before-begin',
  templateUrl: 'proof-terms-before-begin.html',
})
export class ProofTermsBeforeBeginPage {

  public user: any = {
    documentKind: null,
    documentCode: null,
    federalCode: null,
    name: null
  };
  public currentDate: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private platform: Platform,
    private alertProvider: AlertProvider,
    private proof: ProofProvider,
    private proofServer: ProofServerProvider,
    private authProvider: AuthProvider,
    private menu: MenuController,
    private events: Events
  ) {
  }

  ionViewDidLoad() {
    this.setUser();
    this.setCurrentDate();
  }

  onDecline() {
    this.alertProvider.doWaiting('Registrando...');
    this.proofServer.termsNoAcceptance(this.proof.getId()).subscribe({
      next: (): void => {
        // setTimeout((): void => {
        //     this.menu.enable(true);
        //     this.menu.swipeEnable(true);
        //     this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
        //         setTimeout(() => {
        //             this.events.publish('doProofUpdate');
        //         }, 500);
        //     });
        // }, 1000);
        window.location.reload();

        this.alertProvider.doWaitingHide();
      },
      error: (err: any): void => {
        console.error(err);
        this.alertProvider.doWaitingHide();
      }
    });
  }

  onAccept() {
    this.alertProvider.doWaiting('Registrando...');
    this.proofServer.termsAcceptance(this.proof.getId()).subscribe({
      next: (): void => {
        // this.navCtrl.push(ProofBeforeBeginPage);

        let that = this;
        let message;

        // DONE: On mobile HTML tag on message do not work
        if (this.platform.is('cordova')) {
          message = 'Para seguir adiante, é necessário você possuir em mãos um documento de identificação que contenha FOTO + número do CPF (um documento único ou dois documentos diferentes). Deseja continuar?';
        } else {
          message = 'Para seguir adiante, é necessário você possuir em mãos um documento de identificação que contenha <strong>FOTO + número do CPF</strong> (um documento único ou dois documentos diferentes). Deseja continuar?';
        }

        this.alertProvider.doConfirm(message, () => {
          if (that.platform.is('cordova')) {
            that.navCtrl.push(IdentificationCheckOnAppPage);
          } else {
            that.navCtrl.push(IdentificationCheckOnWebPage);
          }
        });

        this.alertProvider.doWaitingHide();
      },
      error: (err: any): void => {
        console.error(err);
        this.alertProvider.doWaitingHide();
      }
    });
  }

  private setUser(): void {
    this.user = {
      documentKind: null,
      documentCode: null,
      federalCode: null,
      name: null
    };

    const user = this.authProvider.getUser();

    if (!user) {
      return;
    }

    if (user.documentKind) {
      try {
        this.user.documentKind = user.documentKind.name;
      } catch (e) {
        // Do nothing.
      }
    }

    this.user.documentCode = user.documentCode;
    this.user.federalCode = user.federalCode;
    this.user.name = user.name;
  }

  private setCurrentDate(): void {
    const today: Date = new Date();

    const options: any = {year: 'numeric', month: 'long', day: '2-digit'};
    const formatted: string = today.toLocaleDateString('pt-BR', options);

    // Remove the day to keep the format "__________ de _________ de 2025"
    const [, day, month, year] = formatted.match(/(\d{2}) de (\w+) de (\d{4})/);

    // Output: "__________ de _________ de 2025" filled with today's values
    this.currentDate = `${day} de ${month} de ${year}`;
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-terms-before-begin/proof-terms-before-begin.ts